import {recoilPersist} from "recoil-persist";
import {atom} from "recoil";

const {persistAtom} = recoilPersist({
    key: "homePersist",
    storage:sessionStorage, //sessionStorage사용
})

// 2️⃣ `메뉴 상태` 데이터를 저장하는 atom
export const homeSubMenuState = atom({
    key: "homeSubMenuState",
    default: "lesson",
    effects_UNSTABLE: [persistAtom]
});
